import { useEffect, useState } from "react";
import { PRESALE_DEADLINE_ISO, PROMO_CODE_UNTIL_ISO } from "../config/site";

const deadlineMs = new Date(PRESALE_DEADLINE_ISO).getTime();
const promoEndMs = new Date(PROMO_CODE_UNTIL_ISO).getTime();

const calcWindow = (targetMs) => {
    const diff = targetMs - Date.now();
    if (diff <= 0) {
        return { ended: true, lastDay: false, days: 0, hours: 0, minutes: 0, seconds: 0 };
    }
    const totalSeconds = Math.floor(diff / 1000);
    return {
        ended: false,
        lastDay: diff <= 86400000,
        days: Math.floor(totalSeconds / 86400),
        hours: Math.floor((totalSeconds % 86400) / 3600),
        minutes: Math.floor((totalSeconds % 3600) / 60),
        seconds: totalSeconds % 60,
    };
};

// Stan promocji na stronie:
// - ended: po terminie Early Bird (ceny przechodzą na regularne)
// - lastDay: ostatnie 24 h Early Bird
// - promoActive: trwa okno kodu zniżkowego -50 zł (do końca 27.10)
// - promoTime: odliczanie do końca okna kodu
const calc = () => {
    const main = calcWindow(deadlineMs);
    const promo = calcWindow(promoEndMs);
    return {
        ...main,
        promoActive: !promo.ended && !main.ended,
        promoTime: promo,
    };
};

export const usePresaleCountdown = () => {
    const [time, setTime] = useState(calc);

    useEffect(() => {
        if (time.ended) return undefined;
        const id = setInterval(() => setTime(calc()), 1000);
        return () => clearInterval(id);
    }, [time.ended]);

    return time;
};

export const pad = (n) => String(n).padStart(2, "0");
